import { memo, ReactNode } from 'react'
import cn from 'classnames'

interface IProps {
  children?: ReactNode
  className?: string
  title?: ReactNode
}

export const ListCardRow = memo(function ListCardRow({ title, children, className }: IProps) {
  return (
    children && (
      <>
        {title && <div className="overflow-hidden text-ellipsis whitespace-nowrap text-on-surface/[.38]">{title}</div>}
        <div className={cn(className, '[&>*]:whitespace-break-spaces')}>{children}</div>
      </>
    )
  )
})
